export const ChannelsTab = {
  directChannels: 'direct-channels',
  channelManagers: 'channel-managers',
};

export const channelsTabSidePanelId = 'channels-tab-side-panel';

export type ChannelsTabType = (typeof ChannelsTab)[keyof typeof ChannelsTab];
